import { Injectable } from '@angular/core';
import { deleteField } from '@angular/fire/firestore';
import { BehaviorSubject } from 'rxjs';
import { COLLECTION_NAMES } from 'src/app/constants/collection.const';
import { FirestoreService } from '../firebase/firestore.service';

@Injectable({
  providedIn: 'root'
})
export class UserLikeService extends FirestoreService {

  private static isInit = false;
  public userLikes: BehaviorSubject<any> = new BehaviorSubject<any>({});

  constructor() { 
    super();

    this.setCollectionRef(COLLECTION_NAMES.USER_LIKE);
  }

  async setup(uid: string) {
    if(UserLikeService.isInit) return;
    UserLikeService.isInit = true;

    let userLikes: any = {};
    const data = await this.get(uid);
    if(data) {
      userLikes = data;
    }
    
    this.userLikes.next(userLikes);
  }

  public unsub() {
    this.userLikes.next({});
    UserLikeService.isInit = false;
  }

  toggleLike(uid: string, saleId: string, like: boolean) {
    let doc = {};
    doc[saleId] = like ? true : deleteField();

    if(like) {
      this.userLikes.value[saleId] = true;
    } else {
      delete this.userLikes.value[saleId];
    }
    this.userLikes.next(this.userLikes.value);

    return this.set(doc, uid);
  }
}
